import * as send from './send';

export default {
  ...send,
};
